import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField, FormControl, Select, MenuItem, InputAdornment, Button } from '@material-ui/core';
import moment from 'moment';

const styles = (theme) => ({
  searchDiv: {
    // padding: '25px 80px',
    backgroundColor: '#f3f3f3',
    display: 'flex',
    justifyContent: 'space-between',
    justifyContentItems: 'center',
  },
  searchBox: {
    width: '69%',
    backgroundColor: '#ffffff',
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0',
    },
  },
  formControl: {
    width: '15%',
  },
  InputAdornment: {
    display: 'block',
    height: '100%',
    maxHeight: '100%',
    margin: 0,
  },
});

class ProgramScientificSearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchDate: 'all',
      searchInput: '',
    };
  }

  handelrDateChange = (e) => {
    const value = e.target.value;
    this.setState({ searchDate: value });
  };
  handelrInputChange = (e) => {
    const value = e.target.value;
    this.setState({ searchInput: value });
  };

  clearSearch = () => {
    this.setState({ searchDate: 'all', searchInput: '' });
    this.props.clearSearch();
  };

  enterInput = () => {
    this.props.search(this.state.searchDate, this.state.searchInput);
    // this.setState({ searchDate: 'all', searchInput: '' });
  };

  render() {
    const { classes, arrDate } = this.props;

    return (
      <Grid item xs={12} className={classes.searchDiv}>
        <FormControl variant="outlined" className={classes.formControl} style={{ backgroundColor: '#ffffff' }}>
          <Select value={this.state.searchDate} onChange={(e) => this.handelrDateChange(e)}>
            <MenuItem value="all">All Day</MenuItem>
            {arrDate.length > 0 &&
              arrDate.map((data, idx) => {
                return (
                  <MenuItem key={`${data}_arrDate_${idx}`} value={idx}>
                    {moment(data).format('MMM. DD (ddd)')}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
        <TextField
          id="Search"
          className={classes.searchBox}
          onChange={(e) => this.handelrInputChange(e)}
          onKeyPress={(e) => e.key === 'Enter' && this.enterInput()}
          value={this.state.searchInput}
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment className={classes.InputAdornment} position="end">
                <Button variant="contained" onClick={(e) => this.enterInput()} color="primary" style={{ width: '100%', height: '100%' }}>
                  Search
                </Button>
              </InputAdornment>
            ),
          }}
        />
        <Button className={classes.formControl} onClick={this.clearSearch} variant="contained" color="primary">
          Clear Search
        </Button>
      </Grid>
    );
  }
}

export default withStyles(styles)(ProgramScientificSearchBar);
